import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

// Assets
import styles from './DisclaimerButton.module.scss'

const DisclaimerButton = ({ children, onClick, className }) => {
  return (
    <div className={classnames(styles.root, className)}>
      <div onClick={onClick}>
        <span className={styles.children}>{children}</span>
      </div>
    </div>
  )
}

DisclaimerButton.propTypes = {
  children: PropTypes.any,
  linkTo: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
}

DisclaimerButton.defaultProps = {
  onClick: () => {},
}

export default DisclaimerButton
